import { Event } from '@trustedshops/tswp-core-common';
import { ChannelDto } from '@trustedshops/account-service-client';

/**
 * Service for handling the  Channel Management
 */
export interface ChannelSelectionService {
  /**
   * Selects a channel.
   *
   * @param channel The channel to select.
   */
  selectChannel(channel: ChannelDto): void;

  /**
   * Gets the currently selected channel
   *
   * @returns An event emitting as soon as the selcted channel changes.
   * Also emits the channel currently selected as the first event when subscribing.
   * Emits `null` when no channel is selected.
   */
  getSelectedChannel(): Event<ChannelDto>;

  /**
   * Gets all channels available to the user (filtered by permission).
   *
   * @returns An event emitting as soon as the list of available containers changes.
   */
  getAllChannels(): Event<ChannelDto[]>;
}